/**
 * SELECT OPTIONS RISKS
 *
 * @version 0.1
 */
import React from 'react';
import { injectIntl } from 'react-intl';

function SelectOptionsRisks({riskLevel, onChange, intl}) {

    const RISKS_SELECT_OPTIONS = {
        'ANY_LEVEL':   'Entities_Preview_UIText_previewCompanies.selectOptionsRisk.allRiskLevels',
        'high':        'Entities_Preview_UIText_previewCompanies.selectOptionsRisk.highOnly',
        'high_medium': 'Entities_Preview_UIText_previewCompanies.selectOptionsRisk.highMedium',
        'medium':      'Entities_Preview_UIText_previewCompanies.selectOptionsRisk.mediumOnly',
        'medium_low':  'Entities_Preview_UIText_previewCompanies.selectOptionsRisk.mediumLow',
        'low':         'Entities_Preview_UIText_previewCompanies.selectOptionsRisk.lowOnly'
    };

    if (!RISKS_SELECT_OPTIONS[riskLevel]) {
        riskLevel = 'ANY_LEVEL';
    }

    let risks = Object.keys(RISKS_SELECT_OPTIONS);

    return (
        <select className="notranslate risk-level-select"
                value={riskLevel}
                onChange={onChange}
                title={intl.formatMessage({id: RISKS_SELECT_OPTIONS[riskLevel]})}>

            {
                risks.map((riskLevel) => (
                    <option key={'risks-option-' + riskLevel} value={riskLevel}>
                        {intl.formatMessage({id: RISKS_SELECT_OPTIONS[riskLevel]})}
                    </option>
                ))
            }

        </select>
    );

}

export default injectIntl(SelectOptionsRisks);


// WEBPACK FOOTER //
// ./src/scripts/reusable/Dropdowns/SelectOptionsRisks.jsx